
import dayjs from 'dayjs';
import 'dayjs/locale/es';


export const obtenerMesCuota = ({bolsillo, totalAhorro, cuotaNormal}) =>{
    dayjs.locale('es');

    let cuotasPagas = ~~(totalAhorro / cuotaNormal)
    let fechaInicio = dayjs(bolsillo.fecha).add(cuotasPagas, 'month')

    return fechaInicio.format('MMMM')


}